import {distanceUnits} from '../../constants/index.js';
import {
  feet,
  identity,
  kilometers,
  miles,
  nauticalMiles,
} from '../conversions.js';
import formatNumber, {
  DEFAULT_FORMAT,
  truncateNumber,
} from '../format-number/format-number.js';
import {getLength} from '../geodetic.js';

const conversionMap = {
  [distanceUnits.metric.m]: n => truncateNumber(identity(n)),
  [distanceUnits.metric.km]: n => truncateNumber(kilometers(n)),
  [distanceUnits.usc.ft]: n => truncateNumber(feet(n)),
  [distanceUnits.usc.mi]: n => truncateNumber(miles(n)),
  [distanceUnits.usc.nmi]: n => truncateNumber(nauticalMiles(n)),
};

export const localizationMap = {
  [distanceUnits.metric.m]: 'common:unitFormat.meters',
  [distanceUnits.metric.km]: 'common:unitFormat.kilometers',
  [distanceUnits.usc.ft]: 'common:unitFormat.feet',
  [distanceUnits.usc.mi]: 'common:unitFormat.miles',
  [distanceUnits.usc.nmi]: 'common:unitFormat.nauticalMiles',
};

const formatDistance = (
  lineString,
  unit = distanceUnits.metric.m,
  format = DEFAULT_FORMAT,
  lengthOptions
) => {
  if (!conversionMap[unit]) {
    return '';
  }

  const meters = getLength(lineString, lengthOptions);
  return formatNumber(meters, conversionMap[unit], format);
};

export default formatDistance;
